import { Component, ChangeDetectionStrategy, signal, OnDestroy, inject, computed, HostListener, effect, Renderer2 } from '@angular/core';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GalleryComponent implements OnDestroy {
  private translationService = inject(TranslationService);
  t = computed(() => this.translationService.t().gallery);

  images = [
    { src: 'assets/images/gallery-01.jpg', alt: 'Baustelle Referenz 1' },
    { src: 'assets/images/gallery-02.jpg', alt: 'Baustelle Referenz 2' },
    { src: 'assets/images/gallery-03.jpg', alt: 'Baustelle Referenz 3' },
    { src: 'assets/images/gallery-04.jpg', alt: 'Baustelle Referenz 4' },
    { src: 'assets/images/gallery-05.jpg', alt: 'Baustelle Referenz 5' },
    { src: 'assets/images/gallery-06.jpg', alt: 'Baustelle Referenz 6' },
    { src: 'assets/images/gallery-07.jpg', alt: 'Baustelle Referenz 7' },
    { src: 'assets/images/gallery-08.jpg', alt: 'Baustelle Referenz 8' },
    { src: 'assets/images/gallery-09.jpg', alt: 'Baustelle Referenz 9' },
    { src: 'assets/images/gallery-10.jpg', alt: 'Baustelle Referenz 10' },
    { src: 'assets/images/gallery-11.jpg', alt: 'Baustelle Referenz 11' },
    { src: 'assets/images/gallery-12.jpg', alt: 'Baustelle Referenz 12' }
  ];

  // --- Lightbox State ---
  isLightboxOpen = signal(false);
  selectedImageIndex = signal<number | null>(null);

  selectedImage = computed(() => {
    const index = this.selectedImageIndex();
    if (index !== null && this.images[index]) {
      return this.images[index];
    }
    return null;
  });

  private renderer = inject(Renderer2);

  constructor() {
    effect(() => {
      if (this.isLightboxOpen()) {
        this.renderer.addClass(document.body, 'overflow-hidden');
      } else {
        this.renderer.removeClass(document.body, 'overflow-hidden');
      }
    });
  }

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent): void {
    if (this.isLightboxOpen()) {
      if (event.key === 'Escape') {
        this.closeLightbox();
      } else if (event.key === 'ArrowRight') {
        this.nextImage();
      } else if (event.key === 'ArrowLeft') {
        this.prevImage();
      }
    }
  }
  
  // --- Lightbox Methods ---
  openLightbox(index: number): void {
    this.selectedImageIndex.set(index);
    this.isLightboxOpen.set(true);
  }

  closeLightbox(): void {
    this.isLightboxOpen.set(false);
    this.selectedImageIndex.set(null);
  }

  nextImage(): void {
    this.selectedImageIndex.update(index => {
      if (index === null) return null;
      const nextIndex = index + 1;
      return nextIndex >= this.images.length ? 0 : nextIndex;
    });
  }

  prevImage(): void {
    this.selectedImageIndex.update(index => {
      if (index === null) return null;
      const prevIndex = index - 1;
      return prevIndex < 0 ? this.images.length - 1 : prevIndex;
    });
  }

  ngOnDestroy(): void {
    // Clean up body class if component is destroyed while lightbox is open
    this.renderer.removeClass(document.body, 'overflow-hidden');
  }
}